var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import styles from './video-page.styles';
import { classMap } from 'lit/directives/class-map.js';
import '../rating/rating';
import { dictionary } from '@mf-cms/helpers';
let PVideoPage = class PVideoPage extends LitElement {
    constructor() {
        super(...arguments);
        this.culture = 'en-GB';
    }
    static { this.styles = styles; }
    /**
    * Render component
    * @returns {TemplateResult} Template
    */
    render() {
        const classes = {
            'theater-mode': this.theaterMode,
            'hide-data': this.hideData
        };
        return html ` <section class="video-page ${classMap(classes)}" aria-label=${`${dictionary(this.culture, 'videoPage', 'ariaVideo')} ${this.name}`} @mp-toggle-theatre-mode=${() => this.theaterMode = !this.theaterMode}>
        <div class="container">
          <div class="player">
            <slot name="player"></slot>
          </div>
          <div class="info">
            <div class="main">
              <h1>${this.name}</h1>
              <div class="meta">
                ${this.live ? html `<p-badge ?dark=${this.dark} color="live">${dictionary(this.culture, 'videoPage', 'live')}</p-badge>` : ''}
                ${this.date ? html ` <time datetime=${this.date}> ${this.date} </time> ` : ''}
                ${this.runtime && this.date ? html ` &middot; ` : ''}
                ${this.runtime ? html `<span class="runtime">${this.runtime}</span>` : ''}
                ${this.viewers ? html ` <div ?dark=${this.dark} class="viewers"> <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye" viewBox="0 0 16 16"> <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z"/> <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0"/> </svg> <span class="sr-only">${dictionary(this.culture, 'videoPage', 'viewers')} </span> ${this.viewers} </div> ` : ''}
              </div>
              <!-- TODO: We need to handle linebreaks and links here -->
              <p class="description">${this.description}</p>
            </div>
            <div class="side">
              <div class="actions">
                <slot name="actions"></slot>
              </div>
              <div class="data">
                <slot name="data"></slot>
              </div>
            </div>
          </div>
        </div>
      </section>
    `;
    }
};
__decorate([
    property({ type: String, reflect: true })
], PVideoPage.prototype, "name", void 0);
__decorate([
    property({ type: String, reflect: true })
], PVideoPage.prototype, "description", void 0);
__decorate([
    property({ type: String, reflect: true })
], PVideoPage.prototype, "runtime", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], PVideoPage.prototype, "live", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], PVideoPage.prototype, "dark", void 0);
__decorate([
    property({ type: Boolean, reflect: true, attribute: 'hide-data' })
], PVideoPage.prototype, "hideData", void 0);
__decorate([
    property({ type: String, reflect: true })
], PVideoPage.prototype, "date", void 0);
__decorate([
    property({ type: Number, reflect: true })
], PVideoPage.prototype, "viewers", void 0);
__decorate([
    property({ type: Boolean, reflect: true, attribute: 'theater-mode' })
], PVideoPage.prototype, "theaterMode", void 0);
__decorate([
    property({ type: String })
], PVideoPage.prototype, "culture", void 0);
PVideoPage = __decorate([
    customElement('p-video-page')
    /**
    * PVideoPage component
    *
    * @class PVideoPage
    * @typedef {PVideoPage}
    * @extends {LitElement}
    */
], PVideoPage);
export { PVideoPage };
